<template>
    <div id="previous-step-button" v-on:click="currentStepIndex--; $emit('backStep')" v-on:keyup.enter="currentStepIndex--; $emit('backStep')" tabindex="0">
        <div id="back-step">
            <div id="back-step-text">
                <span>BACK</span>
                <p>{{ backStepTitle }}</p>
            </div>
            <i class="arrow-left"></i>
        </div>
    </div>
</template>

<script>
    export default {
        name: "previous-step-button",
        data () {
            return {
                stepTitles: ['Purchase Costs', 'Income & Expenses', 'Tax Factors', 'Results']
            }
        },
        props: {
            backStepTitle: String,
            nextStepTitle: String,
            currentStepIndex: Number
        }
    }
</script>

<style scoped>

    #previous-step-button {
        background-color: #ee3124;
        border: 1px solid #ee3124;
        width: 40%;
        min-width: 238px;
        max-width: 270px;
        height: 100px;
        margin: 0 auto;
        margin-bottom: 15px;
        color: #fff;
        font-size: 20px;
        padding-bottom: 15px;
        padding-top: 10px;
        cursor: pointer;
    }

    #back-step {
        text-align: left;
        display: inline-block;
        margin-left: 15px;
    }

    #back-step-text {
        float: right;
    }

    p {
        margin-bottom: 0;
    }

    span {
        font-weight: bold;
        font-size: 30px;
    }

    .arrow-left {
        border: solid #fff;
        border-width: 0 5px 5px 0;
        display: inline-block;
        padding: 12px;
        transform: rotate(135deg);
        -webkit-transform: rotate(135deg);
        float: left;
        margin-top: 25px;
    }

    @media(max-width: 450px) {

        span {
            font-size: 20px;
        }

        p {
            font-size: 16px;
        }

        .arrow-left {
            margin-top: 15px;
        }
    }

    @media(max-width: 370px) {

        span {
            font-size: 16px;
        }

        p {
            font-size: 14px;
        }
    }

</style>


// WEBPACK FOOTER //
// src/Components/PreviousStepButton.vue